module.exports = __webpack_public_path__ + "img/income-chart.900ea8fa.svg";